module.exports = __webpack_public_path__ + "media/images/icon_address01_17-18-213bfba7a6771dea61fa90d0831df1b2.png";